import React from 'react';
import { Container, Paper, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Security from '@material-ui/icons/Security';
import LockOpen from '@material-ui/icons/LockOpen';
import Storage from '@material-ui/icons/Storage';
import Share from '@material-ui/icons/Share';
// MUI icon renamed — avoids clash with react-router-dom Link
import LinkIcon from '@material-ui/icons/Link';
import Block from '@material-ui/icons/Block';
import ContactMail from '@material-ui/icons/ContactMail';
import './Privacy.css';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'var(--theme-bg-color)',
    minHeight: '100vh',
    color: '#fff',
    paddingBottom: '2rem'
  },
  paper: {
    background: 'rgba(255, 255, 255, 0.05)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '10px',
    marginBottom: '1rem'
  },
  typography: {
    color: '#fff',
  },
  heading: {
    color: '#007bff',
    fontSize: '1.5rem',
    fontWeight: 500
  },
  content: {
    color: '#fff',
    '& ul': {
      listStyle: 'none',
      padding: '0',
      margin: '1rem 0',
      '& li': {
        position: 'relative',
        paddingLeft: '1.5rem',
        marginBottom: '0.8rem',
        '&::before': {
          content: '"•"',
          color: '#007bff',
          position: 'absolute',
          left: 0,
          top: '0'
        }
      }
    }
  },
  icon: {
    color: '#007bff',
    marginRight: '0.5rem',
    fontSize: '2rem'
  },
  headerBox: {
    display: 'flex',
    alignItems: 'center',
    padding: '1rem',
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    background: 'rgba(0, 123, 255, 0.1)'
  },
  contentBox: {
    padding: '1.5rem'
  }
}));

const Privacy = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Container maxWidth="lg">
        <Box mb={4} textAlign="center">
          <Security style={{ fontSize: '4rem', color: '#007bff', marginBottom: '1rem' }} />
          <Typography variant="h3" style={{ color: '#fff', marginBottom: '1rem' }}>
            Privacy Policy
          </Typography>
        </Box>

        <Paper elevation={3} className={classes.paper}>
          <Box className={classes.headerBox}>
            <LockOpen className={classes.icon} />
            <Typography variant="h5" className={classes.heading}>
               Information We Collect
            </Typography>
          </Box>
          <Box className={classes.contentBox}>
            <Typography className={classes.content}>
              We collect information that you provide directly to us when using the LED Scroller service:
              <ul>
                <li>Account information (name, email, password)</li>
                <li>Profile information</li>
                <li>Content you create and share</li>
                <li>Communication preferences</li>
              </ul>
            </Typography>
          </Box>
        </Paper>

        <Paper elevation={3} className={classes.paper}>
          <Box className={classes.headerBox}>
            <Storage className={classes.icon} />
            <Typography variant="h5" className={classes.heading}>
              How We Use Your Information
            </Typography>
          </Box>
          <Box className={classes.contentBox}>
            <Typography className={classes.content}>
              We use the collected information for various purposes:
              <ul>
                <li>To provide and maintain our Service</li>
                <li>To notify you about changes to our Service</li>
                <li>To provide customer support</li>
                <li>To gather analysis or valuable information to improve our Service</li>
                <li>To monitor the usage of our Service</li>
                <li>To detect, prevent and address technical issues</li>
              </ul>
            </Typography>
          </Box>
        </Paper>

        <Paper elevation={3} className={classes.paper}>
          <Box className={classes.headerBox}>
            <Share className={classes.icon} />
            <Typography variant="h5" className={classes.heading}>
               Information Sharing
            </Typography>
          </Box>
          <Box className={classes.contentBox}>
            <Typography className={classes.content}>
              We don't share any personally identifying information publicly or with third-parties, except when required to by law.
            </Typography>
            <Typography className={classes.content} style={{ marginTop: '1rem' }}>
              We only retain collected information for as long as necessary to provide you with your requested service. What data we store, we'll protect within commercially acceptable means to prevent loss and theft, as well as unauthorized access, disclosure, copying, use or modification.
            </Typography>
          </Box>
        </Paper>

        <Paper elevation={3} className={classes.paper}>
          <Box className={classes.headerBox}>
            <LinkIcon className={classes.icon} />
            <Typography variant="h5" className={classes.heading}>
               External Links
            </Typography>
          </Box>
          <Box className={classes.contentBox}>
            <Typography className={classes.content}>
              Our website may link to external sites that are not operated by us. Please be aware that we have no control over the content and practices of these sites, and cannot accept responsibility or liability for their respective privacy policies.
            </Typography>
          </Box>
        </Paper>

        <Paper elevation={3} className={classes.paper}>
          <Box className={classes.headerBox}>
            <Block className={classes.icon} />
            <Typography variant="h5" className={classes.heading}>
               Your Rights
            </Typography>
          </Box>
          <Box className={classes.contentBox}>
            <Typography className={classes.content}>
              You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services.
            </Typography>
            <Typography className={classes.content} style={{ marginTop: '1rem' }}>
              Your continued use of our website will be regarded as acceptance of our practices around privacy and personal information.
            </Typography>
          </Box>
        </Paper>

        <Paper elevation={3} className={classes.paper}>
          <Box className={classes.headerBox}>
            <Block className={classes.icon} />
            <Typography variant="h5" className={classes.heading}>
              Content filtering (LED text)
            </Typography>
          </Box>
          <Box className={classes.contentBox}>
            <Typography className={classes.content}>
              To help enforce our Acceptable Use Policy, certain features (such as video export and
              full-screen display) may check your LED message against an on-device word list in your
              browser. This check runs locally. Your LED text is not sent to a third-party content
              moderation API for this filter.
            </Typography>
            <Typography className={classes.content} style={{ marginTop: '1rem' }}>
              We may record aggregate analytics when a content-policy block occurs (for example, a
              count that a block happened), without sending your LED message text or blocked words
              to analytics. This does not change how we work with advertising or analytics partners
              already described in this Privacy Policy. For questions, contact
              usercontactcare@gmail.com.
            </Typography>
          </Box>
        </Paper>

        <Paper elevation={3} className={classes.paper}>
          <Box className={classes.headerBox}>
            <Storage className={classes.icon} />
            <Typography variant="h5" className={classes.heading}>
              Payments &amp; order data
            </Typography>
          </Box>
          <Box className={classes.contentBox}>
            <Typography className={classes.content}>
              When you purchase a video export, we (and our payment partner) process order-related
              data such as Order ID, Guest Access Code, payment status, amount, and Lemon Squeezy
              transaction references needed to confirm payment and unlock download. Card payments are
              handled by Lemon Squeezy; we do not store card data on ledscroller.com servers.
            </Typography>
            <Typography className={classes.content} style={{ marginTop: '1rem' }}>
              If you later create a profile, we may store the name, email, birth date, and password
              credentials you provide. Invoice email and marketing email are optional future features.
              See also our{' '}
              <Link to="/refund-policy" className="privacy-inline-link">
                Refund &amp; Return Policy
              </Link>
              .
            </Typography>
          </Box>
        </Paper>

        <Paper elevation={3} className={classes.paper}>
          <Box className={classes.headerBox}>
            <ContactMail className={classes.icon} />
            <Typography variant="h5" className={classes.heading}>
              6. Contact Information
            </Typography>
          </Box>
          <Box className={classes.contentBox}>
            <Typography className={classes.content}>
              If you have any questions about our Privacy Policy, please contact us:
            </Typography>
            <Box mt={2} display="grid" gridGap={16} gridTemplateColumns={{ xs: '1fr', sm: 'repeat(2, 1fr)' }}>
              <Box>
                <Typography variant="subtitle1" style={{ color: '#007bff', marginBottom: '0.5rem' }}>
                  Email:
                </Typography>
                <Typography className={classes.content}>
                  usercontactcare@gmail.com
                </Typography>
              </Box>
              <Box>
                <Typography variant="subtitle1" style={{ color: '#007bff', marginBottom: '0.5rem' }}>
                  Phone:
                </Typography>
                <Typography className={classes.content}>
                  +91-9898-****
                </Typography>
              </Box>
              <Box style={{ gridColumn: '1 / -1' }}>
                <Typography variant="subtitle1" style={{ color: '#007bff', marginBottom: '0.5rem' }}>
                  Address:
                </Typography>
                <Typography className={classes.content}>
                  Udhana - Magdalla Rd, opp. J H Ambani School, Piplod, Surat, Gujarat 395007
                </Typography>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Container>
    </div>
  );
};

export default Privacy; 